import React from 'react';
import Grid from '@material-ui/core/Grid';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import IconButton from '@material-ui/core/IconButton';

const AddRemove = (props) => {
  return (
    <div className='item-container quantity'>
      <Grid container spacing={0}>
        <Grid item xs={1} />
        <Grid item xs={10}>
          <div
            id='quantity'
            style={{
              border: props.color
                ? `solid 0.8px  ${props.color}`
                : 'solid 0.8px #a79f9f',
            }}
          >
            <div className='quantity-row'>
              <Grid container spacing={8} justify='center'>
                <Grid item xs={3}>
                  <IconButton
                    onClick={props.removeQuantity}
                    title='RemoveQuantity'
                    variant='outlined'
                    style={{ marginTop: 'auto', marginBottom: '13px' }}
                  >
                    {/* <Icon className="quantity-icons" onClick={props.removeQuantity} style={{ fontSize: 30 }}>remove_circle</Icon> */}
                    <RemoveIcon />
                  </IconButton>
                  {/* <Button variant="fab" color="primary"  onClick={props.removeQuantity} aria-label="Add" >
                                        <AddIcon />
                                    </Button> */}
                </Grid>
                <Grid item xs={6}>
                  <p className='added-quantity'>{props.quantity}</p>
                </Grid>
                <Grid item xs={3}>
                  <IconButton
                    onClick={props.addQuantity}
                    title='AddQuantity'
                    variant='outlined'
                    style={{ marginTop: 'auto', marginBottom: '13px' }}
                  >
                    {/* <Icon className="quantity-icons" onClick={props.removeQuantity} style={{ fontSize: 30 }}>remove_circle</Icon> */}
                    <AddIcon />
                  </IconButton>{' '}
                </Grid>
              </Grid>
            </div>
          </div>
        </Grid>
        <Grid item xs={1} />
      </Grid>
    </div>
  );
};
export default AddRemove;



// WEBPACK FOOTER //
// ./src/components/AddRemove.js